import React, { useState, useEffect, useRef } from 'react';
import SplitHero from '../components/SplitHero';
import SellerContent from '../components/SellerContent';
import InfluencerContent from '../components/InfluencerContent';
import SharedFooter from '../components/SharedFooter';
import { useNavigate } from 'react-router-dom';

const HomePage = ({ isAuthenticated }) => {
  const navigate = useNavigate();
  const [chosen, setChosen] = useState(null);       // null | 'seller' | 'influencer'
  const [revealed, setRevealed] = useState(false);  // true once content is visible
  const contentRef = useRef(null);

  // Lock body scroll until a choice is made
  useEffect(() => {
    if (!chosen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      window.scrollTo({ top: 0, behavior: 'smooth' });
      // Mount first, then trigger fade on next frame
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setRevealed(true));
      });
    }
    return () => { document.body.style.overflow = ''; };
  }, [chosen]);

  return (
    <div className="min-h-screen overflow-x-hidden" style={{ background: '#f8fafc', position: 'relative' }}>

      {/* background logo watermarks - visible behind the curtain during transition */}
      <div className="bg-logo-desktop" style={{ position: 'fixed', right: '-1%', top: '43%', transform: 'translateY(-50%)', opacity: revealed ? 0 : 0.04, transition: 'opacity 0.5s ease', pointerEvents: 'none', zIndex: 1 }}>
        <img src="/logo512.png" alt="" style={{ width: 500, height: 500, objectFit: 'contain' }} />
      </div>
      <div style={{ position: 'fixed', left: '7%', top: '65%', transform: 'translateY(-50%)', opacity: revealed ? 0 : 0.04, transition: 'opacity 0.5s ease', pointerEvents: 'none', zIndex: 1 }}>
        <img src="/logo512.png" alt="" style={{ width: 300, height: 300, objectFit: 'contain' }} />
      </div>
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(5deg); }
        }
        .content-reveal {
          opacity: 0;
          transition: opacity 1.1s ease;
          pointer-events: none;
        }
        .content-reveal.is-revealed {
          opacity: 1;
          pointer-events: auto;
        }

        .bg-logo-desktop {
          display: none;
        }
        @media (min-width: 768px) {
          .bg-logo-desktop {
            display: block;
          }
        }

        /* Theater curtain track lines - decorative top bar shown briefly during open */
        .curtain-track {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #0d9488, #2563eb, #7c3aed);
          z-index: 200;
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.4s ease;
        }
        .curtain-track.opening {
          transform: scaleX(1);
        }
        .curtain-track.done {
          opacity: 0;
          transition: transform 0.4s ease, opacity 0.3s ease 0.5s;
        }
      `}</style>

      {/* Theater track bar - flashes across the top as curtains open */}
      <div className={`curtain-track ${chosen ? 'opening' : ''} ${revealed ? 'done' : ''}`} />

      {/* Fixed split-hero overlay - fades out after choice */}
      <SplitHero onChoose={(side) => {
        if (isAuthenticated) { navigate('/dashboard'); return; }
        setChosen(side);
      }} />

      {/*
        Spacer so the document has scroll height even while the overlay is up.
        Once chosen, the real content is revealed below.
      */}
      {!chosen && <div style={{ height: '100vh' }} />}

      {/* Main content - revealed after choice */}
      {chosen && (
        <div ref={contentRef} className={`content-reveal ${revealed ? 'is-revealed' : ''}`}>
          {chosen === 'seller' ? <SellerContent /> : <InfluencerContent />}
          <SharedFooter />
        </div>
      )}
    </div>
  );
};

export default HomePage;